import { TableBody } from 'components/Table/TableBody/TableBody';
import { PatientReportsTable, ReportsStatus } from 'utils/models';
import { queryKeys, queryParams } from 'utils/query';
import { PatientsReportsColumns } from 'components/Table/Columns/PatientsReportsColumns';
import { getReportsOverview } from 'services/reports';
import { ReportsListFilters } from 'components/Table/Filters/ReportsListFilters';
import { TableConfig } from 'models/general';

const patientReportsListConfig: TableConfig = {
  queryKey: queryKeys.patientReports,
  defaultFilters: {
    [queryParams.status]: ReportsStatus.All,
  },
};

export const PatientReportsList = () => {
  return (
    <TableBody<PatientReportsTable>
      getData={getReportsOverview}
      getColumns={PatientsReportsColumns}
      config={patientReportsListConfig}
      filterBar={<ReportsListFilters config={patientReportsListConfig} searchByName={false} />}
    />
  );
};
